module.exports = __webpack_public_path__ + "static/media/payment_methods_mobile.b2ad521b.svg";